import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { CheckIcon } from 'lucide-react';
export function BBLAddOns() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-165">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-166">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-167">
          <h2 className="text-[28px] lg:text-[44px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-168">
            ADD ONS FOR ENHANCED RESULTS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-169"></div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-170">
          <AnimateOnScroll data-id="element-171">
            <div className="bg-[#111111] p-9 border-t-[3px] border-[#FF1493] h-full" data-id="element-172">
              <h3 className="text-white text-[22px] font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-173">
                Exosomes
              </h3>
              <p className="text-[#B0B0B0] text-[15px] leading-[1.7] font-body" data-id="element-174">
                Enhance your BBL treatment with exosomes for even better
                results. When applied immediately after your laser treatment,
                exosomes amplify healing and skin regeneration by delivering
                growth factors and proteins directly to your skin cells. This
                boosts cellular communication and collagen production, reducing
                inflammation and improving skin texture, tone, and overall
                health.
              </p>
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll delay={150} data-id="element-175">
            <div className="bg-[#111111] p-9 border-t-[3px] border-[#FF1493] h-full" data-id="element-176">
              <h3 className="text-white text-[22px] font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-177">
                Our Proprietary "Power Trio"
              </h3>
              <p className="text-[#B0B0B0] text-[15px] leading-[1.7] font-body mb-6" data-id="element-178">
                Optimize your BBL treatment with Be CLINICAL's exclusive Power
                Trio blend. This proprietary mix includes stem cells,
                brightening agents, and peptides, all working together for
                glowing, beautiful results.
              </p>
              <ul className="space-y-4" data-id="element-179">
                <li className="flex items-start gap-3" data-id="element-180">
                  <CheckIcon size={18} className="text-[#FF1493] flex-shrink-0 mt-1" data-id="element-181" />
                  <span className="text-[#B0B0B0] text-sm leading-[1.6] font-body" data-id="element-182">
                    <strong className="text-white" data-id="element-183">Stem Cells</strong> – Our
                    products contain powerful growth factors that stimulate
                    cells to behave younger, promoting rejuvenation and vitality
                    in your skin.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-184">
                  <CheckIcon size={18} className="text-[#FF1493] flex-shrink-0 mt-1" data-id="element-185" />
                  <span className="text-[#B0B0B0] text-sm leading-[1.6] font-body" data-id="element-186">
                    <strong className="text-white" data-id="element-187">Brightening Agents</strong> –
                    A potent combination of glutathione and tranexamic acid
                    evens out your skin tone, giving you a luminous complexion.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-188">
                  <CheckIcon size={18} className="text-[#FF1493] flex-shrink-0 mt-1" data-id="element-189" />
                  <span className="text-[#B0B0B0] text-sm leading-[1.6] font-body" data-id="element-190">
                    <strong className="text-white" data-id="element-191">Peptides</strong> – Our
                    advanced formula works on a cellular level to improve skin
                    cell function, providing them with the necessary building
                    blocks for optimal health and vitality.
                  </span>
                </li>
              </ul>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}